import { render, staticRenderFns } from "./Imagem.vue?vue&type=template&id=917fb47c&scoped=true&"
import script from "./Imagem.vue?vue&type=script&lang=js&"
export * from "./Imagem.vue?vue&type=script&lang=js&"
import style0 from "./Imagem.vue?vue&type=style&index=0&id=917fb47c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917fb47c",
  null
  
)

export default component.exports